import { CloseOutlined } from '@ant-design/icons';
import { styled } from '@aibi-ui/core';
import { Checkbox } from 'antd';
import IconChatDelete from '@gainer-ui/ai-bi-chat/assets/icons/chat-delete.svg';

const DeleteOptionsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 38px;
  border-radius: 6px;
  border: 1px solid #d2d2d2;
  background-color: #f7f8fc;
  gap: 12px;
  .option {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: #333;
    cursor: pointer;
    flex: 1;
    &:hover {
      color: #333;
    }
  }
  .delete {
    svg {
      fill: none;
      width: 16px;
      height: 16px;
    }
  }

  .line {
    width: 1px;
    height: 12px;
    background: #d2d2d2;
  }
`;

const DeleteOptions = ({
  allChecked,
  setAllChecked,
  onDelete,
  onExit,
  canDelete,
}: {
  allChecked: boolean;
  setAllChecked: (checked: boolean) => void;
  onDelete: () => void;
  onExit: () => void;
  canDelete: boolean;
}) => (
  <DeleteOptionsContainer>
    <div className="option" onClick={() => setAllChecked(!allChecked)}>
      <Checkbox
        checked={allChecked}
        onChange={e => setAllChecked(e.target.checked || false)}
      />
      全选
    </div>
    <div className="line" />
    <div
      className="option delete"
      style={{
        color: canDelete ? '#333' : '#999',
      }}
      onClick={onDelete}
    >
      <IconChatDelete viewBox="0 0 16 16" />
      删除
    </div>
    <div className="line" />
    <div className="option" onClick={onExit}>
      <CloseOutlined />
      退出
    </div>
  </DeleteOptionsContainer>
);

export default DeleteOptions;
